export function createUrlSearchParams<T extends Record<string, any>>(params: T): URLSearchParams {
  const urlSearchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      urlSearchParams.set(key, value.toString());
    }
  });
  return urlSearchParams;
}

/**
 * Retrieves the current request URL from headers
 * Falls back to environment variables or a default path
 */
export function getCurrentRequestUrl(headersList: { get(name: string): string | null }): string {
  return headersList.get('x-url') || process.env.NEXT_PUBLIC_BASE_URL || '/';
}

/**
 * Generates a full profile URL with locale support
 * Uses window.location.origin on client side to construct the full URL
 * @param userId - The user's ID
 * @param locale - The locale (e.g., 'en', 'fr')
 * @returns Full URL to the professional profile page
 * @example getProfileUrl('123', 'en') => 'http://localhost:3000/en/professional/123'
 */
export function getProfileUrl(userId: string, locale: string): string {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/${locale}/professional/${userId}`;
  }

  return `/${locale}/professional/${userId}`;
}

/** Path to a Hub's public page. */
export function getHubUrl(hubId: string, locale: string): string {
  return `/${locale}/hub/${hubId}`;
}

/** A Hub's admin page, where its address is changed. */
export function getAdminHubUrl(hubId: string, locale: string): string {
  return `/${locale}/admin/hubs/${hubId}`;
}

/** A Hub's Manager pages: its overview, or one of its sections (`professionals`, `settings`). */
export function getManageHubUrl(hubId: string, locale: string, section?: 'professionals' | 'settings'): string {
  return `/${locale}/manage/hubs/${hubId}${section ? `/${section}` : ''}`;
}
